import { Box, BoxProps, ExpandableCard, Icon, Text, useResponsive } from '@bitrise/bitkit';
import useManualApprovalBuildList, {
  ManualApprovalBuild,
} from '@/pages/App/AppDetails/components/BuildsSection/ManualApprovalBuildList/hooks/useManualApprovalBuildList';
import { SettingsPageAbilities } from '@/pages/App/AppSettings/types/SettingsPageAbilities';
import ManualApprovalBuildListItem from '@/pages/App/AppDetails/components/BuildsSection/ManualApprovalBuildList/ManualApprovalBuildListItem';
import AppForAppPage from '@/pages/App/types/AppForAppPage';

const style = {
  container: {
    color: 'purple.10',
    fontWeight: 'demiBold',
    display: 'flex',
    alignItems: 'center',
    gap: '4',
  } as BoxProps,
  counter: {
    display: 'inline-block',
    paddingX: '8',
    paddingY: '4',
    color: 'neutral.40',
    backgroundColor: 'neutral.93',
    borderRadius: '4',
    _groupActive: {
      color: 'neutral.10',
      backgroundColor: 'neutral.80',
    },
    _groupHover: {
      backgroundColor: 'neutral.90',
    },
  } as BoxProps,
};
const ButtonContent = ({ count }: { count: number }) => (
  <Box __css={style.container}>
    <Icon name="Clock" size="16" />
    <span>Manual approval builds</span>
    <Text as="span" size="1" sx={style.counter}>
      {count}
    </Text>
  </Box>
);

export type ManualApprovalBuildListProps = {
  app: AppForAppPage;
  abilities: SettingsPageAbilities;
};

const ManualApprovalBuildList = ({ app, abilities }: ManualApprovalBuildListProps): JSX.Element | null => {
  const { isMobile } = useResponsive();

  const { data: manualApprovalBuildList, refetch } = useManualApprovalBuildList({
    appSlug: app.slug,
    enabled: abilities.canChangeSettings,
  });

  if (!!manualApprovalBuildList && manualApprovalBuildList.length > 0) {
    return (
      <ExpandableCard
        buttonContent={<ButtonContent count={manualApprovalBuildList.length} />}
        border="1px solid"
        borderColor="neutral.80"
        borderRadius="8"
        backgroundColor="neutral.100"
        isExpanded
        zIndex={isMobile ? 0 : 2}
      >
        {manualApprovalBuildList.map((anItem: ManualApprovalBuild, index) => (
          <ManualApprovalBuildListItem
            key={anItem.slug}
            app={app}
            manualApprovalBuildItem={anItem}
            onRefresh={refetch}
            marginBlockEnd={index < manualApprovalBuildList.length - 1 ? '16' : undefined}
          />
        ))}
      </ExpandableCard>
    );
  }

  return null;
};

export default ManualApprovalBuildList;
